/* so-quick-add-source.js — measure quick-add (2026-09-26; P0-12 2026-09-28: cart attribute, not line properties).
   Every successful add that starts from a product card or the quick-add drawer is recorded in the hidden cart
   attribute _so_src (assets/so-cart-source.js): source "quick-add", via = where the card was
   (collection | home | search | product-recs | page | other), units = the quantity added.
   Nothing is put on the line itself, so the same flavour added later anywhere else joins the SAME line.
   Adds from the product page's own buy box are not recorded (as before).
   How: the quantity is read at submit (capture phase, before product-form.js builds its FormData); after a
   successful add product-form.js fires on:cart:add (new line) or on:line-item:change (line already there) on
   the <product-form>, with detail.variantId. Loaded from snippets/quick-add-drawer.liquid (every page). */
(function () {
  if (window.__soQuickAddSource) return;
  window.__soQuickAddSource = true;

  function via() {
    var p = location.pathname;
    if (p === '/' || p === '') return 'home';
    if (p.indexOf('/collections') === 0) return 'collection';
    if (p.indexOf('/search') === 0) return 'search';
    if (p.indexOf('/products/') === 0) return 'product-recs';
    if (p.indexOf('/pages/') === 0 || p.indexOf('/blogs/') === 0) return 'page';
    return 'other';
  }

  var asked = new WeakMap(); // form -> quantity submitted
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!form.closest('quick-add-drawer, .card')) return;   // only card quick-add + its drawer
    var q = form.querySelector('[name="quantity"]');
    asked.set(form, Math.max(1, parseInt(q && q.value, 10) || 1));
  }, true);

  function onAdded(e) {
    var pf = e.target;
    if (!pf || !pf.closest || !pf.closest('quick-add-drawer, .card')) return;
    var form = pf.querySelector && pf.querySelector('form[action*="/cart/add"]');
    var id = e.detail && e.detail.variantId;
    if (!form || !id || !asked.has(form)) return;
    var n = asked.get(form);
    asked.delete(form);
    if (window.SO && SO.cartSource) SO.cartSource.record(id, 'quick-add', via(), n);
  }
  document.addEventListener('on:cart:add', onAdded);
  document.addEventListener('on:line-item:change', onAdded);
})();
